<template>
    <div class="profile-with-status-bar" :class="{'is-reverse': reverse}">
        <Card class="status-bar" :bordered="false" >
            <slot name="status-bar"></slot>
            <template v-if="!$slots['status-bar']">
                <div class="status" v-if="!reverse"><slot name="status"/></div>
                <div class="button-group"><slot name="button-group"/></div>
            </template>
        </Card>
        <profile-basic class="profile-with-status-bar-body" :style="{height: bodyHeight}" :scrollbar="scrollbar">
            <slot/>
        </profile-basic>
    </div>
</template>

<script>
import ProfileBasic from './profile-basic'
export default {
    name: 'profile-status-bar',
    components: {
        ProfileBasic
    },
    props: {
        scrollbar: {
            type: Boolean,
            default: true
        },
        reverse: { // 状态栏放置到下方
            type: Boolean,
            default: false
        }
    },
    computed: {
        bodyHeight () {
            return 'calc(100% - 74px)'
        }
    },
}
</script>

<style lang="less">
.profile-with-status-bar {
    height: 100%;
    display: flex;
    flex-direction: column;
    .status-bar {
        margin-bottom: 10px;
        height: 64px;
        color: #606266;
        h1, h2, h3, h4, h5, h6 {
            color: #606266;
        }
        .ivu-card-body {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
    &.is-reverse {
        flex-direction: column-reverse;
        .status-bar {
            margin-top: 10px;
            margin-bottom: 0px;
            .ivu-card-body {
                justify-content: center;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/profile-status-bar.vue